import React, { useState } from "react";
import styled from "styled-components";
import variables from "../../../../constants/assets/variables";
import { useHistory } from "react-router-dom";
import { FlexContainer } from "../../../../constants/assets/containers";
import { deleteCookies, isMobile } from "../../../../utils";
import NavSidePanel from "../NavSidePanel";
import Logout from "sushiweb/Icons/all/Logout";
import Button from "sushiweb/Button";
import routesInfo from "../../../../constants/RoutesData";
import FeedbackForm from "../../../FeedbackForm";
import { getDashboardUrl, getLogoutUrl } from "../../../../views/Home";

const NavHeader = (props) => {
  const { menus } = props;
  const history = useHistory();
  const [isSidePanel, setIsSidePanel] = useState(false);
  const [feedbackForm, setFeedbackForm] = useState(false);

  const handleClick = () => {
    setIsSidePanel(!isSidePanel);
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  const handleLogout = () => {
    const logoutUrl = getLogoutUrl();
    deleteCookies(["login_host"]);
    window.location.assign(logoutUrl);
  };

  const getCurrentPathWithoutLastPart = (path) => {
    if (path.lastIndexOf("/") === 0) {
      return path;
    }
    return "/" + path.substr(1).split("/")[0];
  };

  const getOldRouteInfo = (currPath) => {
    const routeObj = routesInfo.routesData;
    const activeEle = Object.keys(routeObj).find(
      (item) =>
        getCurrentPathWithoutLastPart(routeObj[item].path) ===
        getCurrentPathWithoutLastPart(currPath)
    );
    if (activeEle) {
      return routeObj[activeEle]["oldDashboardLink"];
    }
  };

  const handleSubmitFeedbackForm = () => {
    const oldRoute = getOldRouteInfo(history.location.pathname);
    window.open(getDashboardUrl() + oldRoute);
  };

  const handleFeedbackFormClose = () => {
    setFeedbackForm(false);
  };

  const GoBackOldDashboard = () => {
    // setFeedbackForm(true);
    handleSubmitFeedbackForm();
  };

  const isOldRoutePresent = () => {
    const oldRoute = getOldRouteInfo(history.location.pathname);
    return !!oldRoute;
  };

  return (
    <React.Fragment>
      <NavHeader.Container>
        {isMobile() && (
          <NavHeader.Hamburger onClick={handleClick}>
            <img
              src={
                isSidePanel
                  ? "/images/navIcons/cross.svg"
                  : "/images/navIcons/ham.svg"
              }
              alt="ham-img"
            />
          </NavHeader.Hamburger>
        )}
        <NavHeader.LeftSection
          className="cursor-pointer"
          onClick={() => history.push("/")}
        >
          <img
            className="z-logo"
            src="/images/zomato-logo.svg"
            alt="logo-img"
          /> 
          {
            process.env.REACT_APP_ENV === "production" && (
              <NavHeader.Heading>Logistics dashboard</NavHeader.Heading>
            )
          }
        </NavHeader.LeftSection>
        {
            process.env.REACT_APP_ENV !== "production" && (
              <NavHeader.MidSection>
                Logistics Dashboard :
                <NavHeader.Environment>
                  {process.env.REACT_APP_ENV}
                </NavHeader.Environment>
              </NavHeader.MidSection>
            )
        }
        <NavHeader.RightSection>
          {isOldRoutePresent() && (
            <Button
              appearance="outline"
              size="small"
              onClick={GoBackOldDashboard}
              className="sushi-btn mr-20"
            >
              Old view
            </Button>
          )}
          <NavHeader.Avatar className="cursor-pointer">
            <Logout onClick={handleLogout} />
          </NavHeader.Avatar>
        </NavHeader.RightSection>
        {isSidePanel && (
          <SidePanelContainer>
            <NavSidePanel menus={menus} closeSidePanel={handleClick} />
          </SidePanelContainer>
        )}
      </NavHeader.Container>
      {feedbackForm && (
        <FeedbackForm
          handleClose={handleFeedbackFormClose}
          onSubmit={handleSubmitFeedbackForm}
        />
      )}
    </React.Fragment>
  );
};

NavHeader.Container = styled.div`
  width: 100%;
  height: 69px;
  box-shadow: 0px 2px 8px rgba(28, 28, 28, 0.08);
  display: flex;
  max-height: 70px;
  align-items: center;
  padding: 10px 30px;
  justify-content: space-between;
`;

NavHeader.Heading = styled.div`
  color: ${variables.primaryTextColor};
`;

const SidePanelContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  margin-top: 68px;
  padding-top: 20px;
  width: 100%;
  background: #fff;
  z-index: 10;
  height: ${isMobile() ? "100vh" : "calc(100vh - 80px)"};
  overflow: scroll;
`;

NavHeader.Hamburger = styled.div`
  cursor: pointer;
`;

NavHeader.Avatar = styled(FlexContainer)`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: gray;
  justify-content: center;
  img {
    width: 15px;
    height: auto;
  }
`;

NavHeader.Environment = styled.div`
  color: ${process.env.REACT_APP_ENV === "production" ? "red" : "green"};
  font-weight: bold;
  margin-left: 10px;
`;

NavHeader.LeftSection = styled.div`
  img {
    width: unset !important;
  }
`;

NavHeader.MidSection = styled.div`
  font-size: 18px;
  font-weight: bold;
  display: flex;
`;

NavHeader.RightSection = styled.div`
  display: flex;
  align-items: center;
  .sushi-btn {
    min-width: ${isMobile() ? "unset !important" : "8rem"};
    margin-right: ${isMobile() ? "5px" : "20px"};
    span {
      padding: ${isMobile() ? "5px 10px" : "5px 15px"};
    }
  }
`;

export default NavHeader;
